// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f59afae1","453":"3a228c2f","455":"77052879","667":"97d67a62","977":"a019ffc4"}[chunkId] + ".chunk.js";
};